export const register = {
    lang: {
        en: '英文',
        my: '马来文',
        ch: '中文'
    },
    title: '注册',
    type: {
        name: 'ID种类',
        placeholder: 'ID种类',
        required: 'ID种类',
        too_short: '',
        invalid: '',
        defaultText: 'ID种类',
    },
    id_type: [
        { text:"身份证", value: "NRIC" },
        { text:"护照", value: "Passport"  },
        { text:"军人证", value: "Army ID"  },
        { text:"警察证", value: "Police ID"  },
    ],
    firstname: {
        name: ' 名字',
        placeholder: '',
        required: ' 名字',
        too_short: '',
        invalid: '',
    },
    no: {
        name: ' 号码',
        placeholder: ' 号码',
        required: ' 号码',
        too_short: '',
        invalid: '',
    },
    title_gender: '性别',
    gender_list: [
        {
            text: '男性',
            value: '男性',
        },
        {
            text: '女性',
            value: '女性',
        },
    ],
    male: "男性",
    female: "女性",
    race: {
        name: '种族',
        placeholder: '种族',
        required: '种族',
        too_short: '',
        invalid: '',
    },
    flag: [
        { text:"malaysia", value: 0 },
        { text:"singapore", value: 1 },
    ],
    contactNumber: {
        name: '手机号码',
        placeholder: '手机号码',
        required: '',
        too_short: '',
        invalid: '',
    },
    email: {
        name: '电子邮件',
        placeholder: '电子邮件',
        required: '',
        too_short: '',
        invalid: '',
    },
    password: {
        name: '密码',
        placeholder: '密码',
        required: '',
        too_short: '',
        invalid: '',
    },
    confirm_password: {
        name: '确认密码',
        placeholder: '确认密码',
        required: '',
        too_short: '',
        invalid: '',
        match: '',
    },
    text_refer: '推荐朋友（可选）',
    refer_friend: {
        name: '推荐码',
        placeholder: '推荐码',
        required: '',
        too_short: '',
        invalid: '',
    },
    select_img: 'select image',
    pdpa: {
        agree: '请阅读并同意',
        terms: ' 条款 ',
        and: '及',
        privacy: ' 隐私政策'

    },
    btn: '下一页',
    birthdate: {
        name: 'วันเกิด',
        placeholder: 'วันเกิด',
        required: '',
        too_short: '',
        invalid: '',
    },
    otp_title: "请输入OTP号码",
    otp_send_to: "OTP号码已发送至",
    otp_refcode: "Ref号码: ",
    resend_otp: "重发OTP号码于 ",
    send_otp_again: "重发OTP号码",
    verify: "确认",
    invalid_code: "已输入的OTP号码无效， 请再尝试或联络BHPetrol客服服务 03-7719 9499",
    error_code: "错误号码 : ",
    modal_success_title: "注册成功",
    modal_success_subtitle: "您可以使用刚才注册的手机号码登录eCard应用程序。",
    download_app: "下载eCard应用程序",

    validate: {
        input_id: '您输入的身{0}不正确。请输入正确的身{1}份证号码。',
        input_invalid: '已输入的{0}无效。请再尝试。',
        password: '您输入的密码必须至少6至16个字符之间。您的密码不得包含空格或特殊符号。例如：Bhp123。',
        not_match: '您的密码和确认密码不匹配。请再次输入。',
        btn: '关闭'
    },
    valid_mobile: '手机号码',
    valid_email: '电子邮件',

    error: {
        title: "错误",
        err_id: {
            msg: "所输入的ID已被注册。请联系BHPetrol客户服务03-7719 9499以获取协助。"
        },
        err_number: {
            msg: "所输入的联络号码已被注册。请联系BHPetrol客户服务03-7719 9499以获取协助。"
        },
        err_dup_email: {
            msg: "所输入的电子邮件已被注册。请联系BHPetrol客户服务03-7719 9499以获取协助。"
        },
        err_refcode_full: {
            msg: "推荐码使用量已达上限。"
        },
        err_invalid_refcode: {
            msg: "推荐码无效。"
        },
    },
    register_error_title: "错误",
    register_error_msg: "Description: Register unsuccessful. Please call BHPetrol Customer Service Centre for assistance at 03-7719 9499",
}
